<template>
  <div class="form_field flex_field border-bottom align-items-start">
    <div class="label_container_date">
      <div class="date">
        <label for="title" v-if="isNominale">Anno immatricolazione</label>
        <label for="title" v-if="!isNominale">Quotazione richiesta al (mese/anno)</label>
      </div>
    </div>
    <div class="label_container_date">
      <div class="form-group">
        <custom-select
          :options="anniOptions"
          :placeholder="isNominale ? anni : 'Seleziona Anno'"
          name="anno"
          required
          v-model="selectedAnno"
          :isOpen="openDropdown === 0"
          @toggle="handleToggle(0)"
          :disabled="isNominale"
        ></custom-select>
        <custom-select
          :options="mesiOptions"
          placeholder="Seleziona Mese"
          name="mese"
          :required="true"
          v-model="selectedMese"
          :isOpen="openDropdown === 1"
          @toggle="handleToggle(1)"
          :disabled="!isMonthEnabled"
        ></custom-select>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from './CustomSelect.vue';
export default {
  name: 'FormFieldDate',
  components: {
    CustomSelect,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    anni: {
      type: [String, Object],
      required: true,
    },
    mesi: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedAnno: typeof this.anni === 'string' ? this.anni : '',
      selectedMese:
        typeof this.anni === 'string' && this.mesi && this.mesi.valore != null
          ? String(this.mesi.valore)
          : '',
      openDropdown: null,
    };
  },
  computed: {
    isNominale() {
      return this.type === 'nominale' || this.type === 'live-market';
    },
    isMonthEnabled() {
      if (this.isNominale) {
        return !(this.mesi && this.mesi.readonly === true);
      }
      return !!this.selectedAnno;
    },
    anniOptions() {
      if (this.isNominale) {
        return this.anni ? [{ value: this.anni, text: this.anni }] : [];
      }
      const obj = this.anni || {};
      return Object.keys(obj).map(function(k) {
        return { value: String(k), text: obj[k] };
      });
    },
    mesiOptions() {
      if (this.isNominale) {
        const opts = this.mesi && this.mesi.opzioni ? this.mesi.opzioni : {};
        return Object.keys(opts).map(function(k) {
          return { value: String(k), text: opts[k] };
        });
      }
      // storica
      if (!this.selectedAnno) {
        return [];
      }
      const perAnno = this.mesi && this.mesi[this.selectedAnno] ? this.mesi[this.selectedAnno] : {};
      return Object.keys(perAnno).map(function(k) {
        return { value: String(k), text: perAnno[k] };
      });
    },
    isValid() {
      if (this.isNominale) {
        return !!this.selectedMese;
      }
      return !!this.selectedAnno && !!this.selectedMese;
    },
  },
  watch: {
    anni: {
      handler: function(newVal) {
        if (typeof newVal === 'string') {
          this.selectedAnno = newVal || '';
        } else {
          this.selectedAnno = '';
          this.selectedMese = '';
        }
        this.emitValidation();
      },
    },
    mesi: {
      deep: true,
      handler: function() {
        this.selectedMese = '';
        this.emitValidation();
      },
    },
    selectedAnno: function() {
      if (!this.isNominale) {
        this.selectedMese = '';
      }
      this.emitValidation();
    },
    selectedMese: function() {
      this.emitValidation();
    },
  },
  methods: {
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
    emitValidation() {
      this.$emit('validation', this.isValid);
    },
  },
  mounted() {
    this.selectedMese = this.mesi && this.mesi.valore != null ? String(this.mesi.valore) : '';
    this.$nextTick(() => {
      this.emitValidation();
    });
  },
};
</script>

<style scoped>
.pt-0 {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/FormFieldDate.vue